
<div class="ophtalmo">
  <div class='container1'>
    <div class='boxNoBorder box1'>Motif</div>
    <div class='boxNoBorder box2-3'>
      <div style="width: 100%; padding-right: 10px;">
        <div>
        <textarea class="textareaGray" name="motif" [(ngModel)]="contact.ophtalmo.motif" placeholder="" oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'></textarea>
      </div>
    </div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box4'>
      <div class='box l1'></div>
    </div>
  </div>
  <div class='containert1'>
    <div class='boxNoBorder box1'></div>
    <div class='boxNoBorder box2'>
      <div class='box l1 t'>AV OD</div>
      <div class='box spacer'></div>
      <div class='box l1 t'>SPH</div>
      <div class='box l1 t'>CYL</div>
      <div class='box l1 t'>AXE</div>
      <div class='box l1 t'>ADD</div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box3'>
      <div class='box l1 t'>AV OG</div>
      <div class='box spacer'></div>
      <div class='box l1 t'>SPH</div>
      <div class='box l1 t'>CYL</div>
      <div class='box l1 t'>AXE</div>
      <div class='box l1 t'>ADD</div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box4 t'>BINNOC</div>
  </div>
  <div class='container1'>
    <div class='boxNoBorder box1'>SC</div>
    <div class='boxNoBorder box2'>
      <div class='box l1'>
        <div class="input-container l1 container-border-blue">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.scavod" placeholder=""  name="scavod">
        </div>
      </div>
      <div class='box spacer'></div>
      <div class='box l1'></div>
      <div class='box l1'></div>      
      <div class='box l1'></div>      
      <div class='box l1'></div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box3'>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.scavog" placeholder=""  name="scavog">
        </div>
      </div>
      <div class='box spacer'></div>
      <div class='box l1'></div>
      <div class='box l1'></div>      
      <div class='box l1'></div>      
      <div class='box l1'></div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box4'>
      <div class='box l1'>
        <div class="input-container l1 container-border-gray">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.scbinnoc" placeholder="" name="scbinnoc">
        </div>
      </div>
    </div>
  </div>
  <div class='container1'>
    <div class='boxNoBorder box1'>CP LOIN</div>
    <div class='boxNoBorder box2'>
      <div class='box l1'>
        <div class="input-container l1 container-border-blue">
          <input class="input-field-ico" type="text" [(ngModel)]="contact.ophtalmo.cplavod" placeholder="" name="cplavod">
          <button class="btnInput"><fa-icon [icon]="['fas', 'chart-bar']"></fa-icon></button>
        </div>
      </div>
      <div class='box spacer'></div>
      <div class='box l1'>
        <div class="input-container l1 container-border-blue">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.cplsphod" placeholder="" name="cplsphod">
        </div>
      </div>
      <div class="box l1">
        <div class="input-container l1 container-border-blue">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.cplcylod" placeholder="" name="cplcylod">
        </div>
      </div>
      <div class='box l1'>
        <div class="input-container l1 container-border-blue">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.cplaxeod" placeholder="" name="cplaxeod">
        </div>
      </div>
      <div class='box l1'>
        <div class="input-container l1 container-border-blue">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.cpladdod" placeholder="" name="cpladdod">
        </div>
      </div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box3'>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field-ico" type="text" [(ngModel)]="contact.ophtalmo.cplavog" placeholder="" name="cplavog">
          <button class="btnInput"><fa-icon [icon]="['fas', 'chart-bar']"></fa-icon></button>
        </div>
      </div>
      <div class='box spacer'></div>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.cplsphog" placeholder="" name="cplsphog">
        </div>
      </div>
      <div class="box l1">
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.cplcylog" placeholder="" name="cplcylog">
        </div>
      </div>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.cplaxeog" placeholder="" name="cplaxeog">
        </div>
      </div>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.cpladdog" placeholder="" name="cpladdog">
        </div>
      </div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box4'>
      <div class='box l1'>
        <div class="input-container l1 container-border-gray">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.cplbinnoc" placeholder="" name="BINOC-CP LOIN">
        </div>
      </div>
    </div>
  </div>
  <div class='container1'>
    <div class='boxNoBorder box1'>CP PRES</div>
    <div class='boxNoBorder box2'>
      <div class='box l1'>
        <div class="input-container l1 container-border-blue">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.cppavod" placeholder="" name="cppavod">
        </div>
      </div>
      <div class='box spacer'></div>
      <div class='box l1'>
        <div class="input-container l1 container-border-blue">
          <input class="input-field" [(ngModel)]="contact.ophtalmo.cppsphod" type="text" placeholder="" name="cppsphod">
        </div>
      </div>
      <div class="box l1">
        <div class="input-container l1 container-border-blue">
            <input class="input-field" [(ngModel)]="contact.ophtalmo.cppcylod" type="text" placeholder="" name="cppcylod">
        </div>
      </div>
      <div class='box l1'>
        <div class="input-container l1 container-border-blue">
          <input class="input-field" [(ngModel)]="contact.ophtalmo.cppaxeod" type="text" placeholder="" name="cppaxeod">
        </div>
      </div>
      <div class='box l1'></div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box3'>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.cppavog" placeholder="" name="cppavog">
        </div>
      </div>
      <div class='box spacer'></div>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field" [(ngModel)]="contact.ophtalmo.cppsphog" type="text" placeholder="" name="cppsphog">
        </div>
      </div>

      <div class="box l1">
        <div class="input-container l1 container-border-red">
            <input class="input-field" [(ngModel)]="contact.ophtalmo.cppcylog" type="text" placeholder="" name="cppcylog">
        </div>
      </div>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field" [(ngModel)]="contact.ophtalmo.cppaxeog" type="text" placeholder="" name="cppaxeog">
        </div>
      </div>
      <div class='box l1'></div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box4'>
      <div class='box l1'>
        <div class="input-container l1 container-border-gray">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.cppbinnoc" placeholder="" name="cppbinnoc">
        </div>
      </div>
    </div>
  </div>
  <div class='container1'>
    <div class='boxNoBorder box1'>AUTO-REF</div>
    <div class='boxNoBorder box2'>
        <div class='box l1'>
          <div class="input-container l1 container-border-blue">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.autorefavod" placeholder="" name="autorefavod">
          </div>
        </div>
        <div class='box spacer'></div>
        <div class='box l1'>
          <div class="input-container l1 container-border-blue">
            <input class="input-field" [(ngModel)]="contact.ophtalmo.autorefsphod" type="text" placeholder="" name="autorefsphod">
          </div>
        </div>
        <div class="box l1">
          <div class="input-container l1 container-border-blue">
              <input class="input-field" [(ngModel)]="contact.ophtalmo.autorefcylod" type="text" placeholder="" name="autorefcylod">
          </div>
        </div>
        <div class='box l1'>
          <div class="input-container l1 container-border-blue">
            <input class="input-field" [(ngModel)]="contact.ophtalmo.autorefaxeod" type="text" placeholder="" name="autorefaxeod">
          </div>
        </div>
        <div class='box l1'>
          <div class="input-container l1 container-border-blue">
            <input class="input-field" [(ngModel)]="contact.ophtalmo.autorefindtransod" type="text" placeholder="ind. trans." name="autorefindtransod">
          </div>
        </div>
        <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box3'>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.autorefavog" placeholder="" name="autorefavog">
        </div>
      </div>
      <div class='box spacer'></div>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.autorefsphog" placeholder="" name="autorefsphog">
        </div>
      </div>
      <div class="box l1">
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.autorefcylog" placeholder="" name="autorefcylog">
        </div>
      </div>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.autorefaxeog" placeholder="" name="autorefaxeog">
        </div>
      </div>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field" [(ngModel)]="contact.ophtalmo.autorefindtransog" type="text" placeholder="ind. trans." name="autorefindtransog">
        </div>
      </div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box4'>
      <div class='box l1'>
        <div class="input-container l1 container-border-gray">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.autorefbinnoc" placeholder="" name="autorefbinnoc">
        </div>
      </div>
    </div>
  </div>
  <div class='container1'>
    <div class='boxNoBorder box1'>REF-SUB L</div>
    <div class='boxNoBorder box2'>
      <div class='box l1'>
        <div class="input-container l1 container-border-blue">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.refslavod" placeholder="" name="refslavod">
        </div>
      </div>
      <div class='box spacer'></div>
      <div class='box l1'>
        <div class="input-container l1 container-border-blue">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.refslsphod" placeholder="" name="refslsphod">
        </div>
      </div>
      <div class="box l1">
        <div class="input-container l1 container-border-blue">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.refslcylod" placeholder="" name="refslcylod">
        </div>
      </div>
      <div class='box l1'>
        <div class="input-container l1 container-border-blue">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.refslaxeod" placeholder="" name="refslaxeod">
        </div>
      </div>
      <div class='box l1'>
        <div class="input-container l1 container-border-blue">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.refsladdod" placeholder="" name="refsladdod">
        </div>
      </div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box3'>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.refslavog" placeholder="" name="refslavog">
        </div>
      </div>
      <div class='box spacer'></div>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.refslsphog" placeholder="" name="refslsphog">
        </div>
      </div>
      <div class="box l1">
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.refslcylog" placeholder="" name="refslcylog">
        </div>
      </div>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.refslaxeog" placeholder="" name="refslaxeog">
        </div>
      </div>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.refsladdog" placeholder="" name="refsladdog">
        </div>
      </div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box4'>
      <div class='box l1'>
        <div class="input-container l1 container-border-gray">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.refslbinnoc" placeholder="" name="refslbinnoc">
        </div>
      </div>
    </div>
  </div>
  <div class='container1'>
    <div class='boxNoBorder box1'>REF-SUB P</div>
    <div class='boxNoBorder box2'>
      <div class='box l1'>
          <div class="input-container l1 container-border-blue">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.refspavod" placeholder="" name="refspavod">
          </div>
        </div>
        <div class='box spacer'></div>
        <div class='box l1'>
          <div class="input-container l1 container-border-blue">
            <input class="input-field" [(ngModel)]="contact.ophtalmo.refspsphod" type="text" placeholder="" name="refspsphod">
          </div>
        </div>
        <div class="box l1">
          <div class="input-container l1 container-border-blue">
              <input class="input-field" [(ngModel)]="contact.ophtalmo.refspcylod" type="text" placeholder="" name="refspcylod">
          </div>
        </div>
        <div class='box l1'>
          <div class="input-container l1 container-border-blue">
            <input class="input-field" [(ngModel)]="contact.ophtalmo.refspaxeod" type="text" placeholder="" name="refspaxeod">
          </div>
        </div>
        <div class='box l1'></div>
        <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box3'>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.refspavog" placeholder="" name="refspavog">
        </div>
      </div>
      <div class='box spacer'></div>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.refspsphog" placeholder="" name="refspsphog">
        </div>
      </div>
      <div class="box l1">
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.refspcylog" placeholder="" name="refspcylog">
        </div>
      </div>
      <div class='box l1'>
        <div class="input-container l1 container-border-red">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.refspaxeog" placeholder="" name="refspaxeog">
        </div>
      </div>
      <div class='box l1'></div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box4'>
      <div class='box l1'>
        <div class="input-container l1 container-border-gray">
          <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.refspbinnoc" placeholder="" name="refspbinnoc">
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="!showPresc" style="padding-top: 7px; padding-bottom: 5px " class='container1'>
    <button (click)=toggleDisplayDivIfPresc()  class="btn">Prescription</button>
  </div>
  <div style="height: 5px;"> </div>
  <div *ngIf="showPresc" class='containerGrpBG'>
    <div style='padding-top: 5px; padding-bottom: 5px' class='container2'>
      <div style="color: white;"  class='boxNoBorderG box1'>PRESC</div>
      <div class='boxNoBorderG box2'>
        <div class='box l1'>
          <button (click)="copy()" class="btn">
            <fa-icon  [icon]="['fas', 'paste']"></fa-icon>
          </button>
        </div>
        <div class='box spacer'></div>
        <div class='box l1'>
          <div class="input-container l1 container-border-blue">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.prescsphod" placeholder="" name="prescsphod">
          </div>
        </div>
        <div class="box l1">
          <div class="input-container l1 container-border-blue">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.presccylod" placeholder="" name="presccylod">
          </div>
        </div>
        <div class='box l1'>
          <div class="input-container l1 container-border-blue">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.prescaxeod" placeholder="" name="prescaxeod">
          </div>
        </div>
        <div class='box l1'>
          <div class="input-container l1 container-border-blue">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.prescaddod" placeholder="" name="prescaddod">
          </div>
        </div>
        <div class='box spacer'></div>
      </div>
      <div class='boxNoBorder box3'>
        <div class='box l1'></div>
        <div class='box spacer'></div>
        <div class='box l1'>
          <div class="input-container l1 container-border-red">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.prescsphog" placeholder="" name="prescsphog">
          </div>
        </div>
        <div class="box l1">
          <div class="input-container l1 container-border-red">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.presccylog" placeholder="" name="presccylog">
          </div>
        </div>
        <div class='box l1'>
          <div class="input-container l1 container-border-red">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.prescaxeog" placeholder="" name="prescaxeog">
          </div>
        </div>
        <div class='box l1'>
          <div class="input-container l1 container-border-red">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.prescaddog" placeholder="" name="prescaddog">
          </div>
        </div>
        <div class='box spacer'></div>
      </div>
      <div class='boxNoBorderG box4'>
        <div class='boxG l1'></div>
      </div>
    </div>
    <div class='container2'>
      <div class='boxNoBorderG box1'></div>
      <div class='boxNoBorderG box2'>
        <div class='box l1'></div>
        <div class='box spacer'></div>
        <div class='box l1'>
          <div class="input-container l1 container-border-blue">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.presccorsphod" placeholder="" name="presccorsphod">
          </div>
        </div>
        <div class="box l1">
          <div class="input-container l1 container-border-blue">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.presccorcylod" placeholder="" name="presccorcylod">
          </div>
        </div>
        <div class='box l1'>
          <div class="input-container l1 container-border-blue">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.presccoraxeod" placeholder="" name="presccoraxeod">
          </div>
        </div>
        <div class='box l1'></div>
        <div class='box spacer'></div>
      </div>
      <div class='boxNoBorder box3'>
        <div class='box l1'></div>
        <div class='box spacer'></div>
        <div class='box l1'>
          <div class="input-container l1 container-border-red">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.presccorsphog" placeholder="" name="presccorsphog">
          </div>
        </div>
        <div class="box l1">
          <div class="input-container l1 container-border-red">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.presccorcylog" placeholder="" name="presccorcylog">
          </div>
        </div>
        <div class='box l1'>
          <div class="input-container l1 container-border-red">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.presccoraxeog" placeholder="" name="presccoraxeog">
          </div>
        </div>
        <div class='box l1'></div>
        <div class='box spacer'></div>
      </div>
      <div class='boxNoBorderG box4'>
        <div class='boxG l1'></div>
      </div>
    </div>
    <div class='container2'>
       <div class='boxNoBorderG box1'></div>
       <div class='boxNoBorderG box2'>
         <div style="color: white;" class='boxG l2 txt'>TYPE VERRES</div>
         <div class="boxG">
           <div class="input-container l2 container-border-gray">
           <input list="type-verres" [(ngModel)]="contact.ophtalmo.presctypeverre" name="type-verres" class="listBox">
           <datalist id="type-verres">
              <option value="unifocal loin">
              <option value="unifocal près">
              <option value="bifocal">
              <option value="progressif">
              <option value="dégressif">  
              <option value="lentille">
           </datalist>
         </div>
        </div>
        </div>
        <div class='boxNoBorderG box3'>
          <div style="color: white;" class='boxG l2 txt'>AUTRES CARACT</div>
          <div class="boxG">
            <div class="input-container l2 container-border-gray">
              <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.presccaractverre" placeholder="" name="AUTRES CARACT">
            </div>
        </div>  
        </div>
        <div class='boxNoBorderG box4'></div>
      </div>
    </div>
    <div style="height: 5px;"> </div>
  <div class='container1'>
    <div class='boxNoBorder box1'>CYCLO</div>
    <div class='boxNoBorder box2'>
      <div class='box l1'></div>
      <div class='box spacer'></div>
      <div class='box l1'>
        <div class="input-container l1 container-border-blue">
          <input class="input-field" [(ngModel)]="contact.ophtalmo.cyclosphod" type="text" placeholder="" name="cyclosphod">
        </div>
      </div>
      <div class="box l1">
        <div class="input-container l1 container-border-blue">
            <input class="input-field" [(ngModel)]="contact.ophtalmo.cyclocylod" type="text" placeholder="" name="cyclocylod">
        </div>
      </div>
      <div class='box l1'>
        <div class="input-container l1 container-border-blue">
          <input class="input-field" [(ngModel)]="contact.ophtalmo.cycloaxeod" type="text" placeholder="" name="cycloaxeod">
        </div>
      </div>
      <div class='box l1'></div>
      <div class='box spacer'></div>
  </div>
  <div class='boxNoBorder box3'>
    <div class='box l1'></div>
    <div class='box spacer'></div>
    <div class='box l1'>
      <div class="input-container l1 container-border-red">
        <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.cyclosphog" placeholder="" name="cyclosphog">
      </div>
    </div>
    <div class="box l1">
      <div class="input-container l1 container-border-red">
        <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.cyclocylog" placeholder="" name="cyclocylog">
      </div>
    </div>
    <div class='box l1'>
      <div class="input-container l1 container-border-red">
        <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.cycloaxeog" placeholder="" name="cycloaxeog">
      </div>
    </div>
    <div class='box l1'></div>
    <div class='box spacer'></div>
  </div>
    <div class='boxNoBorder box4'>
      <div style="padding-left: 10px;" class='boxNoBorder l0'>PD</div>
    </div>
  </div>
  <div style='padding-bottom: 5px;' class='container1'>
    <div class='boxNoBorder box1'>REM REF</div>
    <div class='boxNoBorder box2'>
      <div class='box l2'>
        <input class="input-field container-border-blue" type="text" [(ngModel)]="contact.ophtalmo.remrefod" placeholder="" name="remrefod">
      </div>
      <div class='box spacer'></div>
      <div class='boxNoBorder l1-5'>TROU STENOP.</div>
      <div class='box l1-5'>
        <input class="input-field container-border-blue" type="text" [(ngModel)]="contact.ophtalmo.troustenod"  placeholder="" name="troustenod">
      </div>
    </div>
    <div class='boxNoBorder box3'>
      <div class='box l2'>
        <input class="input-field container-border-red" type="text" [(ngModel)]="contact.ophtalmo.remrefog" placeholder="" name="remrefog">
      </div>
      <div class='box spacer'></div>
      <div class='boxNoBorder l1-5'></div>
      <div class='box l1-5'>
        <input class="input-field container-border-red" type="text" [(ngModel)]="contact.ophtalmo.troustenog"  placeholder="" name="troustenog">
      </div>
    </div>
    <div class='boxNoBorder box4'>
      <div class='box l1'>
        <input class="input-field container-border-gray" type="text" [(ngModel)]="contact.ophtalmo.pda"  placeholder="" name="pda">
      </div>
    </div>
  </div>
    <div style='padding-top: 10px' class='container1'>
      <div class='boxNoBorder box1'></div>
      <div class='boxNoBorder box2'>
        <div class='box l1'></div>
        <div class='box spacer'></div>
        <div class='box l1'>
          <div class="input-container l1 container-border-blue">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.k1od"   placeholder="K1" name="kerasphod">
          </div>
        </div>
        <div class="box l1">
          <div class="input-container l1 container-border-blue">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.k1axeod"   placeholder="k1 axe" name="keracylod">
          </div>
        </div>
        <div class='box l1'>
          <div class="input-container l1 container-border-blue">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.k2od"   placeholder="K2" name="kerataxeod">
          </div>
        </div>
        <div class='box l1'>
          <div class="input-container l1 container-border-blue">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.k2axeod"   placeholder="K2 axe" name="kerataxeod">
          </div>
        </div>
        <div class='box spacer'></div>
      </div>
      <div class='boxNoBorder box3'>
        <div class='box l1'></div>
        <div class='box spacer'></div>
        <div class='box l1'>
          <div class="input-container l1 container-border-red">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.k1og"   placeholder="k1" name="k1og">
          </div>
        </div>
        <div class="box l1">
          <div class="input-container l1 container-border-red">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.k1axeog"   placeholder="k1 axe" name="k1axeog">
          </div>
        </div>
        <div class='box l1'>
          <div class="input-container l1 container-border-red">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.k2og"   placeholder="K2" name="k2og">
          </div>
        </div>
        <div class='box l1'>
          <div class="input-container l1 container-border-red">
            <input class="input-field" type="text" [(ngModel)]="contact.ophtalmo.k2axeog"   placeholder="k2 axe" name="k2axeog">
          </div>
        </div>
        <div class='box spacer'></div>
      </div>
      <div class='boxNoBorder box4'>
        <div class='box l1'></div>
    </div>
  </div>
  <div class='container1'>
    <div class='boxNoBorder box1'>TIO AUTO</div>
    <div class='boxNoBorder box2-3'>
      <div class='box l0'>
        <input class="input-field container-border-blue" type="text" [(ngModel)]="contact.ophtalmo.tioautood"  placeholder="" name="tioautood">
      </div>
      <button class="btn1"><fa-icon class="graph" [icon]="['fas', 'chart-bar']"></fa-icon></button>
      <div class='box l0'>
        <input class="input-field container-border-red" type="text" [(ngModel)]="contact.ophtalmo.tioautoog"  placeholder="" name="tioautood">
      </div>
      <div class='box spacer'></div>
      <div class='boxNoBorder l1'>TIO APLA</div>
      <div class='box l0'>
        <input class="input-field container-border-blue" type="text" [(ngModel)]="contact.ophtalmo.tioaplaod"  placeholder="" name="tioautood">
      </div>
      <button class="btn1"><fa-icon class="graph" [icon]="['fas', 'chart-bar']"></fa-icon></button>
      <div class='box l0'>
        <input class="input-field container-border-red" type="text" [(ngModel)]="contact.ophtalmo.tioaplaog"  placeholder="" name="tioautood">
      </div>
      <div class='box spacer'></div>
      <div class='boxNoBorder l1'>PACHY</div>
      <div class='box l0'>
        <input class="input-field container-border-blue" type="text" [(ngModel)]="contact.ophtalmo.pachyod"  placeholder="" name="pachyod">
      </div>
      <div class='box l0'>
        <input class="input-field container-border-red" type="text" [(ngModel)]="contact.ophtalmo.pachyog"  placeholder="" name="pachyog">
      </div>
      <div class='box spacer'></div>
      <div class='boxNoBorder l1'>TIO COR</div>
      <div class='box l0'>
        <input class="input-field container-border-blue" type="text" [(ngModel)]="contact.ophtalmo.tiocorod"  placeholder="" name="tiocorod">
      </div>
      <button class="btn1"><fa-icon class="graph" [icon]="['fas', 'chart-bar']"></fa-icon></button>
      <div class='box l0'>
        <input class="input-field container-border-red" type="text" [(ngModel)]="contact.ophtalmo.tiocorog"  placeholder="" name="tiocorog">
      </div>
      <div class='box spacer'></div>
      <div class='boxNoBorder l0'>HTO</div>
      <div class='box l0'>
        <input class="input-field container-border-red" type="text" [(ngModel)]="contact.ophtalmo.hto"  placeholder="" name="hto">
      </div>
    </div>
    <div class='boxNoBorder box4'></div>
  </div>



  <div style="padding-top: 10px;"> 
    <button (click)=toggleDisplayDivIfAmsler() class="btn">Amsler</button>
    <button (click)=toggleDisplayDivIfFo() class="btn">FO</button>
    <button (click)=toggleDisplayDivIfLaf() class="btn">Laf</button>
    <button (click)=toggleDisplayAll() class="btn">ALL</button>
  </div>


  <div *ngIf="showLaf || showAll" class='container1'>
    <div class='boxNoBorder box1'>LAF</div>
    <div class='boxNoBorder box2'>
      <div class='box'>
        <div class="input-container">
          <textarea class="textareaBlue" name="fafod" [(ngModel)]="contact.ophtalmo.lafod" placeholder="" oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'></textarea>
        </div>
      </div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box3'>
      <div class='box'>
        <div class="input-container">
          <textarea class="textareaRed" name="lafog" [(ngModel)]="contact.ophtalmo.lafog" placeholder="" oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'></textarea>
        </div>
      </div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box4'>
      <div class='box l1'></div>
    </div>
  </div>
  <div *ngIf="showFo || showAll" class='container1'>
    <div class='boxNoBorder box1'>FO
      <label style="margin-left: 1.5em; margin-right: 1em; margin-top: 0.55em;">Dil.</label>   
      <input class="txt" style="margin-top: 0em;" type="checkbox" [(ngModel)]="contact.ophtalmo.fodil" id="dil" name="fo-dil">
    </div>
    <div class='boxNoBorder box2'>
      <div class='box'>
        <div class="input-container">
          <textarea class="textareaBlue" name="food" [(ngModel)]="contact.ophtalmo.food" placeholder="" oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'></textarea>
        </div>
      </div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box3'>
      <div class='box'>
        <div class="input-container">
          <textarea class="textareaRed" name="foog" [(ngModel)]="contact.ophtalmo.foog" placeholder="" oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'></textarea>
        </div>
      </div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box4'>
      <div class='box l1'></div>
    </div>
  </div>
  <div class='container1'>
    <div class='boxNoBorder box1'>CV</div>
    <div class='boxNoBorder box2'>
      <div class='box'>
        <div class="input-container container-border-blue">
          <input class="input-field" [(ngModel)]="contact.ophtalmo.cvod" type="text" placeholder="" name="cvod">
        </div>
      </div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box3'>
      <div class='box'>
        <div class="input-container container-border-red">
          <input class="input-field" [(ngModel)]="contact.ophtalmo.cvog" type="text" placeholder="" name="cvog">
        </div>
      </div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box4'>
      <div class='box l1'></div>
    </div>
  </div>

  <div *ngIf="showAmsler || showAll" class='container1'>
    <div class='boxNoBorder box1'>Amsler</div>
    <div class='boxNoBorder box2'>
      <div class='box'>
        <div class="input-container">
          <textarea class="textareaBlue" name="fafod" [(ngModel)]="contact.ophtalmo.amslerod" placeholder="" oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'></textarea>
        </div>
      </div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box3'>
      <div class='box'>
        <div class="input-container">
          <textarea class="textareaRed" name="lafog" [(ngModel)]="contact.ophtalmo.amslerog" placeholder="" oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'></textarea>
        </div>
      </div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box4'>
      <div class='box l1'></div>
    </div>
  </div>

  <div class='container1'>
    <div class='boxNoBorder box1'>EX. COMPL</div>
    <div class='boxNoBorder box2-3'>
      <div style="width: 100%; padding-right: 10px;">
        <div>
        <textarea class="textareaGray" name="Ex. Compl" [(ngModel)]="contact.ophtalmo.excomp" placeholder="" oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'></textarea>
        </div>
      </div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box4'>
      <div class='box l1'></div>
    </div>
  </div>
  <div class='container1'>
    <div class='boxNoBorder box1'>DIAGNOSTIC</div>
    <div class='boxNoBorder box2-3'>
      <div style="width: 100%; padding-right: 10px;">
        <div>
        <textarea class="textareaGray" name="diagnostic" [(ngModel)]="contact.ophtalmo.diagnostic" placeholder="" oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'></textarea>
        </div>
      </div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box4'>
      <div class='box l1'></div>
    </div>
  </div>
  <div class='container1'>
    <div class='boxNoBorder box1'>A FAIRE</div>
    <div class='boxNoBorder box2-3'>
      <div style="width: 100%; padding-right: 10px;">
        <div>
        <textarea class="textareaGray" name="todo" [(ngModel)]="contact.ophtalmo.todo" placeholder="" oninput='this.style.height = "";this.style.height = this.scrollHeight + "px"'></textarea>
        </div>
      </div>
      <div class='box spacer'></div>
    </div>
    <div class='boxNoBorder box4'>
      <div class='box l1'></div>
    </div>
  </div>

</div>
